import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

// Homepage teaser for the Free Policy Review. Sits directly under the overview
// video. Centered layout matching the brand's editorial style.
export const PolicyReviewSection = () => (
  <section
    id="policy-review"
    data-testid="policy-review-section"
    className="bg-[#E7DECE] py-24 md:py-32"
  >
    <div className="container-lr">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-2xl mx-auto text-center"
      >
        <div className="flex items-center justify-center gap-4">
          <span className="gold-rule" />
          <p className="eyebrow">Free Policy Review</p>
          <span className="gold-rule" />
        </div>
        <h2 className="mt-6 font-serif font-semibold tracking-display text-legacy text-3xl md:text-4xl lg:text-5xl leading-[1.08]">
          Already have life insurance?
          <span className="block italic font-normal text-gold mt-1">Let’s look at it together.</span>
        </h2>
        <p className="mt-6 text-slate text-base md:text-lg leading-relaxed">
          Not sure what you own, how it works, or whether it supports your goals? Send me a
          copy and I’ll give you an honest, educational review — complimentary and private.
        </p>
        <div className="mt-9 flex justify-center">
          <Link
            to="/policy-review"
            data-testid="policy-review-cta"
            className="btn-base btn-outline-dark text-[0.8rem] tracking-[0.14em] uppercase"
          >
            Request a Policy Review
            <ArrowRight size={17} />
          </Link>
        </div>
      </motion.div>
    </div>
  </section>
);
